import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const refreshAccessToken = async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_GATEAWAY}/users/refresh`,
      {}, // body
      { withCredentials: true } // config
    );

    if (data.token) {
      return data.token;
    } else {
      throw new Error("No token returned from refresh");
    }
  } catch (err) {
    console.error("Failed to refresh access token:", err);
    return null;
  }
};

let refreshTimeout;

export const scheduleTokenRefresh = (token, setToken) => {
  const expiry = jwtDecode(token).exp * 1000; // ms
  const now = Date.now();

  // Refresh 1 minute before expiration
  const refreshIn = expiry - now - 60_000;

  console.log(
    "expiry:", new Date(expiry).toISOString(),
    "now:", new Date(now).toISOString(),
    "refreshIn (ms):", refreshIn,
    "refreshIn (sec):", Math.round(refreshIn / 1000)
  );

  if (refreshTimeout) clearTimeout(refreshTimeout);

  refreshTimeout = setTimeout(async () => {
    const newToken = await refreshAccessToken();
    console.log("newToken", newToken);

    if (newToken) {
      setToken(newToken);
      // Update localStorage with the new token
      localStorage.setItem("token", newToken);
      scheduleTokenRefresh(newToken, setToken); // reschedule
    } else {
      console.log("Refresh failed, user needs to login again");
      setToken(null);
      // Clear localStorage when refresh fails
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  }, Math.max(refreshIn, 0));
};

export const clearRefreshTimer = () => {
  if (refreshTimeout) clearTimeout(refreshTimeout);
};




export function validateToken(token) {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);

    // Token has "exp" in seconds → convert to ms
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      // expired
      return null;
    }

    return decoded;
  } catch {
    return null; // invalid token
  }
}
